export var SqlEngineSortField;
(function (SqlEngineSortField) {
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_CREATED_AT"] = "createdAt";
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_NAME"] = "name";
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_MAX_WORKERS"] = "maxWorkers";
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_MIN_WORKERS"] = "minWorkers";
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_CURRENT_REPLICAS"] = "currentReplicas";
    SqlEngineSortField["SQL_ENGINE_SORT_FIELD_WORKER_SIZE"] = "workerSize";
})(SqlEngineSortField || (SqlEngineSortField = {}));
